import { omit, get, isString } from 'lodash/fp'
import { toPathString } from 'e-submission/utils'
import { APP_STATUS, UPLOAD_DOC_STATUS, REMOTE_SELLING } from 'e-submission/domain/data-model/constants'

// import generateUUID from 'uuid/v1'
import { v1 as generateUUID } from 'uuid'

export const setReplicationStatus = (status) => ({
  type: 'SET_REPLICATION_STATUS',
  payload: status,
})

export const setDefaultDCA = () => ({
  type: 'SET_DEFAULT_DCA',
})

export const setAllocationBeneficiaryMRTA = () => ({
  type: 'SET_ALLOCATION_BENEFICIARY_MRTA',
})

export const updateDCA = () => ({
  type: 'UPDATE_DCA',
})

export const signedDCA = () => ({
  type: 'SIGNED_DCA',
})

export const cleanDCA = () => ({
  type: 'CLEAN_DCA',
})

export const checkAccount = (formType, stateATP) => {
  return {
    type: 'CHECK_ACC',
    payload: { formType: formType, state: stateATP },
  }
}

export const submitRecurringPayment = () => ({
  type: 'SUBMIT_RECURRING_PAYMENT',
})

export const startRemoteBankClearing = () => ({
  type: 'START_REMOTE_BANK_CLEARING',
})

export const updateRecurringPayment = (isEdit = false) => ({
  type: 'UPDATE_RECURRING_PAYMENT',
  isEdit,
})

export const setSubmitWithPayment = () => {
  return unsetAppValue('submitWithoutPayment.reason')
}

export const updateReceipt = (id, name) => ({
  type: 'UPDATE_RECEIPT',
  id,
  name,
})

export const updateUnsignReceipt = (id, name, isUploaded, isLongDelay) => ({
  type: 'UPDATE_UNSIGN_RECEIPT',
  id,
  name,
  isUploaded,
  isLongDelay,
})

export const comfirmAttachPayment = (id) => ({
  type: 'CONFIRM_ATTACH_PAYMENT',
  id,
})

export const createReceipt = (payload) => ({
  type: 'CREATE_RECEIPT',
  payload,
})

export const autoCheckingPayment = () => ({
  type: 'CHECKING_BACKWARD_PAYMENT',
})

export const removePaymentReceipt = (payload) => ({
  type: 'REMOVE_PAYMENT_RECEIPT',
  payload,
})

export const submitCreditCard = (payload) => ({
  type: 'SUBMIT_CREDIT_CARD',
  payload,
})

export const fetchSignature = () => ({
  type: 'FETCH_SIGNATURE',
})

export const previewPDF = (payload) => ({
  type: 'PREVIEW_PDF',
  payload,
})

export const previewMultiplePDF = (payload) => ({
  type: 'PREVIEW_MULTIPLE_PDF',
  payload,
})

export const signDocument = (payload) => ({
  type: 'SIGN_DOCUMENT',
  payload,
})

export const capturePhoto = (name, isShowPreview = false) => ({
  type: 'CAPTURE_PHOTO',
  name,
  isShowPreview,
})

export const pickFromGallery = (name, isShowPreview = false) => ({
  type: 'PICK_FROM_GALLERY',
  name,
  isShowPreview,
})

export const browsePhoto = (name, images, isShowPreview = false, remoteSellingActor, format) => ({
  type: 'BROWSE_PHOTO',
  payload: images,
  name,
  isShowPreview,
  remoteSellingActor,
  format,
})

export const browsePhotoOCR = (name, images, isShowPreview = false, remoteSellingActor, format) => ({
  type: 'BROWSE_PHOTO',
  payload: images,
  name,
  isShowPreview,
  remoteSellingActor,
  format,
  ocr: true,
})

export const clonePhoto = (from, destination) => ({
  type: 'CLONE_PHOTO',
  from,
  destination,
})

export const getUnsignedDocImg = (name) => ({
  type: 'GET_UNSIGNED_DOC_IMG',
  name,
})

export const previewPhoto = (name) => ({
  type: 'PREVIEW_PHOTO',
  name,
})

export const deletePhoto = (name) => ({
  type: 'DELETE_PHOTO',
  name,
})

export const addFile = (name, file, fileProps = {}) => ({
  type: 'ADD_FILE',
  payload: { file, ...fileProps },
  name,
})
export const addFileProps = (name, fileProps = {}) => ({
  type: 'ADD_FILE',
  payload: fileProps,
  name,
})

export const removeFile = (name) => ({
  type: 'REMOVE_FILE',
  name,
})

export const addError = (name, error) => ({
  type: 'ADD_ERROR',
  payload: error,
  name,
})

export const removeError = (name) => ({
  type: 'REMOVE_ERROR',
  name,
})

export const saveEcbrPhoto = (from, destination) => ({
  type: 'SAVE_ECBR_PHOTO',
  from,
  destination,
})

export const createNewApp = (user) => {
  const userId = get('profile.sub', user)
  const agentType = get('profile.agent_type', user)
  const agentCode = get('profile.agent_code', user)
  const uuid = generateUUID()
  const appId = `application_${agentType}-${agentCode}_${uuid}`
  return {
    type: 'CREATE_NEW_APP',
    appId,
  }
}

export const loadQuickQuote = (payload) => ({
  type: 'LOAD_QUICK_QUOTE',
  payload,
})

export const loadApplication = (app) => {
  const _id = get('_id', app) || get('id', app)
  return {
    type: 'LOAD_APP',
    appId: _id,
    payload: omit(['id', 'rev', '_rev'], app),
  }
}

export const submitApplication = () => ({
  type: 'SUBMIT_APPLICATION',
})

export const sendApplication = (payload) => ({
  type: 'SEND_APPLICATION',
  payload,
})

export const mergeApplication = (appId, payload) => {
  return {
    type: 'MERGE_APP',
    appId,
    payload,
  }
}

export const changeCurrentApp = (appId) => {
  return {
    type: 'CHANGE_CURRENT_APP',
    appId,
  }
}

export const clickApplicationCard = (appId) => {
  return {
    type: 'HANDLE_CLICKING_APPLICATION_CARD',
    appId,
  }
}

export const fetchApplication = (isWaitCompletedSync = false) => ({
  type: 'FETCH_ALL_APP',
  payload: isWaitCompletedSync,
})

export const setAppValue = (fieldId, value, isExcludeNull) => {
  let newValue = value

  if (isString(value)) {
    const trimmedStringValue = value && value.trim()
    newValue = trimmedStringValue
  }
  return {
    type: 'SET_APP_VALUE',
    fieldId: isString(fieldId) ? fieldId : toPathString(fieldId),
    value: newValue,
    isExcludeNull,
  }
}
// The diffrent between SET_APP_VALUE VS SAVE_APP_DATA
// SET_APP_VALUE is per field. while SAVE_APP_DATA is type to save current state
export const saveAppData = () => ({
  type: 'SAVE_APP_DATA',
})
export const setAppStatusDrafted = () => {
  return setAppValue('status', APP_STATUS.DRAFTED)
}
export const setAppStatusSigned = () => {
  return setAppValue('status', APP_STATUS.SIGNED)
}
export const setAppStatusSubmitted = () => {
  return setAppValue('status', APP_STATUS.SUBMITTED)
}
export const setAppStatusSubmitting = () => {
  return setAppValue('status', APP_STATUS.SUBMITTING)
}
export const setAppStatusFailed = () => {
  return setAppValue('status', APP_STATUS.FAILED)
}

export const setInsuredCommandStatusUploading = (name) => {
  return setAppValue('insuredUploadDocStatus', { status: UPLOAD_DOC_STATUS.UPLOADING, name })
}
export const setPayerCommandStatusUploading = (name) => {
  return setAppValue('payerUploadDocStatus', { status: UPLOAD_DOC_STATUS.UPLOADING, name })
}
export const setInsuredCommandStatusCompleted = (name) => {
  return setAppValue('insuredUploadDocStatus', { status: UPLOAD_DOC_STATUS.COMPLETED, name })
}
export const setPayerCommandStatusCompleted = (name) => {
  return setAppValue('payerUploadDocStatus', { status: UPLOAD_DOC_STATUS.COMPLETED, name })
}
export const setUploadingStatus = (insuredOrPayer, value) => {
  return setAppValue(`${insuredOrPayer}UploadDocStatus`, {
    status: value ? UPLOAD_DOC_STATUS.COMPLETED : UPLOAD_DOC_STATUS.UPLOADING,
  })
}

export const setPreviewMultipleDoc = (name) => {
  return setAppValue('previewMultipleDoc', name)
}

export const setDefaultAppValue = (fieldId, value) => {
  return {
    type: 'SET_DEFAULT_APP_VALUE',
    fieldId: isString(fieldId) ? fieldId : toPathString(fieldId),
    value,
  }
}

export const unsetAppValue = (fieldId) => {
  return {
    type: 'UNSET_APP_VALUE',
    fieldId: isString(fieldId) ? fieldId : toPathString(fieldId),
  }
}

export const addAppMember = (fieldId) => {
  return {
    type: 'ADD_APP_MEMBER',
    fieldId,
  }
}

export const removeAppMember = (fieldId) => {
  return {
    type: 'REMOVE_APP_MEMBER',
    fieldId,
  }
}

export const setData = (obj) => {
  return {
    type: 'SET_DATA',
    payload: obj,
  }
}

export const updateData = (obj) => {
  return {
    type: 'UPDATE_DATA',
    payload: obj,
  }
}

export const showDialog = (dialog) => ({
  type: 'SHOW_DIALOG',
  payload: isString(dialog) ? { name: dialog } : dialog,
})
export const loadDocument = (document) => {
  return {
    type: 'LOAD_DOCUMENT',
    payload: document,
  }
}

export const setLoadingMessage = (payload) => ({
  type: 'SET_LOADING_MESSAGE',
  payload,
})

export const clearLoadingMessage = () => ({
  type: 'CLEAR_LOADING_MESSAGE',
})

export const showPreviewPDFDialog = (document) => {
  return showDialog({
    name: 'PreviewPDF',
    document,
  })
}
export const showPreviewMultiplePDFDialog = (document) => {
  return showDialog({
    name: 'PreviewMultiplePDF',
    document,
  })
}
export const showSignatureDialog = (document) => {
  return showDialog({
    name: 'Signature',
    document,
  })
}
export const showErrorDialog = (type, caption) => {
  return showDialog({
    name: 'Error',
    type,
    caption,
  })
}
export const showSubmitPaymentDialog = (props) => {
  return showDialog({
    name: 'SubmitPayment',
    ...props,
  })
}
export const showSyncingDialog = (props = {}) => {
  return showDialog({
    name: 'Syncing',
    ...props,
  })
}

export const hideDialog = () => ({
  type: 'HIDE_DIALOG',
})

export const showLoading = () => ({
  type: 'SHOW_LOADING',
})

export const hideLoading = () => ({
  type: 'HIDE_LOADING',
})

export const showModalLoading = () => ({
  type: 'SHOW_MODAL_LOADING',
})

export const hideModalLoading = () => ({
  type: 'HIDE_MODAL_LOADING',
})

export const showAgeRevalidating = () => ({
  type: 'SHOW_MODAL_REVALIDATE_AGE',
})

export const hideAgeRevalidating = () => ({
  type: 'HIDE_MODAL_REVALIDATE_AGE',
})

export const validateApplication = () => ({
  type: 'VALIDATE_APPLICATION',
})

export const resetValidation = () => ({
  type: 'RESET_VALIDATION',
})

export const showSignPad = (payload) => ({
  type: 'SHOW_SIGNPAD',
  payload,
})

export const showSubmittedFlashMessage = () => ({
  type: 'SHOW_SUBMITTED_FLASH_MESSAGE',
})

export const hideSubmittedFlashMessage = () => ({
  type: 'HIDE_SUBMITTED_FLASH_MESSAGE',
})

export const confirmYes = () => ({ type: 'CONFIRM_YES' })
export const confirmNo = () => ({ type: 'CONFIRM_NO' })
export const setOnOtp = () => setAppValue('isOnOtp', true)
export const setOffOtp = () => setAppValue('isOnOtp', false)
export const setSendLinkTextInput = (field, payload) => setAppValue(field, payload)
export const setSendLinkMethod = (field, payload) => setAppValue(field, payload)
export const setResendEkycLink = (insuredOrPayer) => setAppValue(`ekycInfo.${insuredOrPayer}.resendLink`, true)
export const startSubmitPage = () => ({ type: 'START_SUBMIT_PAGE' })

const remoteSellingFields = REMOTE_SELLING.fields
export const setEmailRemoteSelling = (email) => setAppValue(remoteSellingFields.email, email)
export const setPhoneNumberRemoteSelling = (phoneNumber) => setAppValue(remoteSellingFields.phoneNumber, phoneNumber)
export const setSendingMethodRemoteSelling = (sendingMethod) =>
  setAppValue(remoteSellingFields.sendingMethod, sendingMethod)
export const closeSendingLinkModalRemoteSelling = () => setAppValue(remoteSellingFields.isLinkModalOpen, false)
export const openSendingLinkModalRemoteSelling = () => setAppValue(remoteSellingFields.isLinkModalOpen, true)
export const setRemoteSellingResumeState = (value) => setAppValue(remoteSellingFields.resumeState, value)
export const closeRemoteSellingResumeModal = () => setAppValue(remoteSellingFields.isResendModalOpen, false)
export const openRemoteSellingResumeModal = () => setAppValue(remoteSellingFields.isResendModalOpen, true)
export const enableAppmanRemoteSelling = () => setAppValue(remoteSellingFields.selectedRemoteSelling, true)
export const disableAppmanRemoteSelling = () => setAppValue(remoteSellingFields.selectedRemoteSelling, false)
export const enableEkycOnDevice = () => setAppValue('ekycInfo.isOnDevice.value', true)
export const disabledEkycOnDevice = () => setAppValue('ekycInfo.isOnDevice.value', false)
export const openNewRemoteSellingPreviewInfoModal = () =>
  setAppValue(remoteSellingFields.isOpenNewRemoteSellingPreviewInfoModal, true)
export const closeNewRemoteSellingPreviewInfoModal = () =>
  setAppValue(remoteSellingFields.isOpenNewRemoteSellingPreviewInfoModal, false)

export const setFlagCheckStatus = () => ({ type: 'SET_EDA_CHECK_STATUS' })

export const verifyPolicy = (history) => ({
  type: 'VERIFY_POLICY',
  payload: history,
})

export const comfirmSubmittedPolicy = (history) => ({
  type: 'CONFIRM_SUBMITTED_POLICY',
  payload: history,
})
export const submittedPolicy = (history) => ({
  type: 'SUBMITTED_POLICY',
  payload: history,
})

export const errorOtpAttachment = (payload) => ({
  type: 'ERROR_OTP_ATTACHMENTS',
  payload,
})

export const subscribeReplicationStatus = () => ({
  type: 'SUBSCRIBE_REPLICATION_STATUS',
})

export const unsubscribeReplicationStatus = () => ({
  type: 'UNSUBSCRIBE_REPLICATION_STATUS',
})

export const createCaseEkyc = (insuredOrPayer, citizenId, passportNumber, onDupModal) => ({
  type: 'CREATE_CASE_EKYC',
  payload: { insuredOrPayer, citizenId, passportNumber, onDupModal },
})

export const createCaseEkycFromDevice = (
  insuredOrPayer,
  citizenId,
  passportNumber,
  openRespondModalOnFailedCase,
  onDupModal
) => {
  return {
    type: 'CREATE_CASE_EKYC_DEVICE',
    payload: { insuredOrPayer, citizenId, passportNumber, openRespondModalOnFailedCase, onDupModal },
  }
}

export const reuseCaseEkyc = (insuredOrPayer, proprietorId) => ({
  type: 'REUSE_CASE_EKYC',
  payload: { insuredOrPayer, proprietorId },
})

export const verifyEkyc = (insuredOrPayer) => ({
  type: 'VERIFY_EKYC',
  payload: { insuredOrPayer },
})

export const getAttachment = (imageName, insuredOrPayer) => ({
  type: 'GET_ATTACHMENT',
  payload: { imageName, insuredOrPayer },
})

export const setFaceRecognitionImageType = 'SET_FACE_RECOGINTION_IMAGE'
export const setFaceRecognitionImage = (image, insuredOrPayer) => ({
  type: setFaceRecognitionImageType,
  payload: { image, insuredOrPayer },
})

export const setFaceImageType = 'SET_FACE_IMAGE'
export const setFaceImage = (image, insuredOrPayer) => ({
  type: setFaceImageType,
  payload: { image, insuredOrPayer },
})

export const setFrontPassportImage = (image, insuredOrPayer) => ({
  type: 'SET_FRONT_PASSPORT_IMAGE',
  payload: { image, insuredOrPayer },
})

export const setFrontIdCardImage = (image, insuredOrPayer) => ({
  type: 'SET_FRONT_ID_CARD_IMAGE',
  payload: { image, insuredOrPayer },
})

export const setBackIdCardLaserCode = (laserCode, insuredOrPayer) => ({
  type: 'SET_BACK_ID_CARD_LASER_CODE',
  payload: { laserCode, insuredOrPayer },
})

export const setDopaRequestFailedModal = (isOpenDopaRequestFailedModal, insuredOrPayer) => ({
  type: 'SET_DOPA_REQUEST_FAILED_MODAL',
  payload: { isOpenDopaRequestFailedModal, insuredOrPayer },
})

export const setOpenIdentifyRespondingModal = (isOpenIdentifyRespondingModal, insuredOrPayer) => ({
  type: 'SET_OPEN_IDENTIFY_RESPONDING_MODAL',
  payload: { isOpenIdentifyRespondingModal, insuredOrPayer },
})

export const sendLinkQuickpay = () => ({
  type: 'SEND_LINK_QUICK_PAY',
})

export const verifyPayment = (isFromBackward) => ({
  type: 'VERIFY_PAYMENT',
  payload: { isFromBackward },
})

export const verifyCCPA = () => ({
  type: 'VERIFY_CCPA',
})
export const checkPaymentStatus = (toggleQuickpayModal) => ({
  type: 'CHECK_PAYMENT_STATUS',
  payload: { toggleQuickpayModal },
})

export const checkQrPaying = (creditCardPaymentMethod, isRemoteSelling, toggleQuickpayModal, toggleModal) => ({
  type: 'CHECK_QR_PAYING',
  payload: { creditCardPaymentMethod, isRemoteSelling, toggleQuickpayModal, toggleModal },
})

export const changePaymentMethod = () => ({
  type: 'CHANGE_PAYMENT_METHOD',
})

export const changeCCPAMethod = () => ({
  type: 'CHANGE_CCPA_METHOD',
})

export const remoteSellingError = (payload) => ({
  type: 'REMOTE_SELLING_ERROR',
  payload,
})

export const remoteSellingSuccess = () => ({
  type: 'REMOTE_SELLING_SUCCESS',
})

export const saveDataAuraToMiddelware = (payload) => ({
  type: 'SAVE_DATA_AURA_TO_MIDDLEWARE',
  payload,
})

export const updateHealthSession = (payload) => ({
  type: 'UPDATE_HEALTH_SESSION',
  payload,
})

export const sendLinkCCPA = () => ({
  type: 'SEND_LINK_CCPA',
})

export const createCCPADefaultValue = (value) => ({
  type: 'CREATE_CCPA_DEFAULT_VALUE',
  value,
})

export const resendLinkCCPA = () => ({
  type: 'RESEND_LINK_CCPA',
})

export const updateConsentEdaTerms = () => ({
  type: 'UPDATE_CONSENT_EDA_TERMS',
})

export const updateConsentDCATerms = () => ({
  type: 'UPDATE_CONSENT_DCA_TERMS',
})

export const readConsentEdaComplete = () => ({
  type: 'READ_CONSENT_EDA_COMPLETE',
})

export const resetConsentEdaComplete = () => ({
  type: 'RESET_CONSENT_EDA_COMPLETE',
})

export const readConsentDCAComplete = () => ({
  type: 'READ_CONSENT_DCA_COMPLETE',
})

export const resetConsentDCAComplete = () => ({
  type: 'RESET_CONSENT_DCA_COMPLETE',
})

export const startEDACheckingStatus = () => ({
  type: 'START_EDA_CHECK_STATUS',
})

export const stopEDACheckingStatus = () => ({
  type: 'STOP_EDA_CHECK_STATUS',
})

export const updateEnhancedAddressStatus = (status) => ({
  type: 'UPDATE_ENHANCED_ADDRESS_STATUS',
  payload: status,
})

export const unsetEDACheckStatus = () => ({
  type: 'UNSET_EDA_CHECK_STATUS',
})

export const setEDACheckStatusError = () => ({
  type: 'EDA_CHECK_STATUS_ERROR',
})

export const setEDACheckStatusExpired = () => ({
  type: 'EDA_CHECK_STATUS_EXPIRED',
})

export const setEDACheckStatusSuccess = () => ({
  type: 'EDA_CHECK_STATUS_SUCCESS',
})

export const setEDACheckStatusRejected = () => ({
  type: 'EDA_CHECK_STATUS_REJECTED',
})

export const setEDAViewFormOnly = () => ({
  type: 'SET_EDA_VIEW_FORM_ONLY',
})

export const resetEDAViewFormOnly = () => ({
  type: 'RESET_EDA_VIEW_FORM_ONLY',
})

export const setShowEcbrSystemizationFailedModal = () => ({
  type: 'SHOW_ECBR_SYSTEMIZATION_FAILED_MODAL',
  payload: { isOpenModal: true },
})

export const setHideEcbrSystemizationFailedModal = () => ({
  type: 'HIDE_ECBR_SYSTEMIZATION_FAILED_MODAL',
  payload: { isOpenModal: false },
})

export const pretendPayingQrCode = () => ({
  type: 'PRETEND_PAYING_QR_CODE',
})

export const createEcbrNo = (id, paymentType) => ({
  type: 'CREATE_ECBR_NO',
  id,
  paymentType,
})

export const downloadEcbrFile = (payload) => ({
  type: 'SAVE_DOWNLOAD_ECBR_FILE',
  payload,
})

export const createNewEda = (payload) => ({
  type: 'CREATE_NEW_EDA',
  payload,
})

export const verifyOcr = (payload) => ({
  type: 'VERIFY_OCR',
  payload,
})

export const getEdaStatus = (toggleModal) => ({
  type: 'GET_EDA_STATUS',
  toggleModal,
})

export const removeEDACheckStatus = () => ({
  type: 'REMOVE_EDA_CHECK_STATUS',
})

export const changeEdaBankAccount = () => ({
  type: 'CHANGE_EDA_BANK_ACCOUNT',
})

export const searchLuckyNumberOptions = () => ({
  type: 'SEARCH_LUCKY_NUMBER_OPTIONS',
})

export const setUsedLuckyNumberModal = (payload) => ({
  type: 'SET_USED_LUCKY_NUMBER_MODAL',
  payload,
})

export const setConfirmLuckyNumberModal = (payload) => ({
  type: 'SET_CONFIRM_LUCKY_NUMBER_MODAL',
  payload,
})

export const setAutoAssignFailedModal = (payload) => ({
  type: 'SET_AUTO_ASSIGN_FAILED_MODAL',
  payload,
})

export const setAutoAssignLuckyNumber = (payload) => ({
  type: 'SET_AUTO_ASSIGN_LUCKY_NUMBER',
  payload,
})

export const submitSelectedLuckyNumber = () => ({
  type: 'SUBMIT_SELECTED_LUCKY_NUMBER',
})

export const setCheckAccount = (app, type) => ({
  type: 'SET_CHECK_ACCOUNT',
  payload: { app, type },
})

export const VerifyCheckAccountATP = (payload) => ({
  type: 'VERIFY_CHECK_ACCOUNT_ATP',
  payload,
})

export const VerifyCheckAccountDCA = (payload) => ({
  type: 'VERIFY_CHECK_ACCOUNT_DCA',
  payload,
})

export const initRemoteSelling = (payload) => ({
  type: 'INIT_REMOTE_SELLING',
})

export const initOldRemoteSelling = (payload) => ({
  type: 'INIT_OLD_REMOTE_SELLING',
})

export const requestAIUW = () => ({
  type: 'REQUEST_AIUW',
})
export const requestAIUWwithGetStaus = () => ({
  type: 'REQUEST_AIUW_WITH_GET_STATUS',
})

export const getAIUWStatus = () => ({
  type: 'GET_AIUW_STATUS',
})

export const reValidateAge = (appId) => {
  return {
    type: 'RE_VALIDATE_AGE',
    payload: {
      appId,
    },
  }
}

export const reGenBI = (appId, status) => {
  return {
    type: 'REGEN_BI',
    payload: {
      appId,
      status,
    },
  }
}

export const saveNewBI = () => {
  return {
    type: 'SAVE_NEW_BI',
  }
}

export const discardNewBI = () => {
  return {
    type: 'DISCARD_NEW_BI',
  }
}

// lost in quick-quote\ocr\ConsentOCRPage.js

export const readConsentOCRComplete = () => {
  return {
    type: 'READ_CONSENT_OCR_COMPLETE',
  }
}

export const resetConsentOCRComplete = () => {
  return {
    type: 'RESET_CONSENT_OCR_COMPLETE',
  }
}

export const iProLoadApp = (appId, status) => {
  return {
    type: 'IPRO_LOAD_APP',
    payload: {
      appId,
      status,
    },
  }
}

export const changeCurrentAppSuccess = (status) => {
  return {
    type: 'CHANGE_CURRENT_APPLICATION_SUCCESS',
    status,
  }
}

export const confirmSubmitDCA = () => ({
  type: 'CONFIRM_SUBMIT_DCA',
})

export const setReuseEkycSelected = (value) => ({
  type: 'SET_REUSE_EKYC_SELECTED',
  payload: value,
})

export const resetReuseEkycSelected = () => ({
  type: 'RESET_REUSE_EKYC_SELECTED',
})

export const setIsAcknowledgeAgeChanged = (value) => ({
  type: 'SET_IS_ACKNOWLEDGE_AGE_CHANGED',
  payload: value,
})

export const resetIsAcknowledgeAgeChanged = () => ({
  type: 'RESET_IS_ACKNOWLEDGE_AGE_CHANGED',
})

export const updateSourceData = (status) => ({
  type: 'UPDATE_SOURCE_DATA',
  payload: status,
})
